module.exports = __webpack_public_path__ + "logo-border.bf2a8bc1.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/src/img/logo-border.svg
// module id = 1338
// module chunks = 0